import React from "react";
import { PageLayout } from "../components/PageLayout";

import "../styles/app.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import { NewsletterSignupBanner } from "src/components/NewsletterSignup";
import { IntroAnimation } from "src/components/IntroAnimation";
import { ArticleBody } from "src/components/ArticleBody";

export const Homepage = () => {
  return (
    <PageLayout>
      <div className="app">
        <IntroAnimation />
        <ArticleBody />
        <NewsletterSignupBanner />
      </div>
    </PageLayout>
  );
};
